import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Star04 = function Star04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m12 2 2.012 5.231c.282.7333.423 1.1.6422 1.4083.1944.2733.4332.5121.7065.7065.3084.2192.675.3602 1.4082.6422L22 12l-5.2311 2.012c-.7332.282-1.0998.423-1.4082.6422a3 3 0 0 0-.7065.7065c-.2192.3084-.3602.675-.6422 1.4082L12 22l-2.012-5.2311c-.282-.7332-.423-1.0998-.6422-1.4082a3 3 0 0 0-.7065-.7065c-.3084-.2192-.675-.3602-1.4082-.6422L2 12l5.231-2.012c.7333-.282 1.1-.423 1.4083-.6422a3 3 0 0 0 .7065-.7065c.2192-.3084.3602-.675.6422-1.4082z"
    })
  }));
};
export default Star04;